import type { ComponentRegistry } from '@json-render/react';
import { type FC, type ReactNode, createContext, useContext } from 'react';

const RegistryContext = createContext<ComponentRegistry | null>(null);

export const useRegistry = (): ComponentRegistry => {
  const registry = useContext(RegistryContext);
  if (!registry) {
    throw new Error('useRegistry must be used within a RegistryProvider');
  }
  return registry;
};

export const RegistryProvider: FC<{
  registry: ComponentRegistry;
  children: ReactNode;
}> = ({ registry, children }) => (
  <RegistryContext.Provider value={registry}>
    {children}
  </RegistryContext.Provider>
);
